<div class="watchlist-edit-dialog">
  <div class="header">
    <h2 mat-dialog-title>{{ getTitle() }}</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="content">
    <div *ngIf="serverError" class="error-message">
    <mat-error>{{ serverError }}</mat-error> 
    </div>
    <br>
    <form [formGroup]="editForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Watchlist Name</mat-label>
        <input matInput 
               formControlName="watchlist_name"
               placeholder="Enter watchlist name"
               maxlength="255">
        <mat-hint>Choose a descriptive name for your watchlist</mat-hint>
        <mat-error *ngIf="editForm.get('watchlist_name')?.invalid && editForm.get('watchlist_name')?.touched">
          {{ getErrorMessage('watchlist_name') }}
        </mat-error>
      </mat-form-field>

      <div *ngIf="mode === 'edit' && watchlist" class="watchlist-info">
        <div class="info-item">
          <mat-icon>business</mat-icon>
          <span>{{ watchlist.company_count || 0 }} companies</span>
        </div>
        <div class="info-item">
          <mat-icon>schedule</mat-icon>
          <span>Created {{ watchlist.created_at | date:'short' }}</span>
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="actions">
    <button mat-button (click)="onCancel()" [disabled]="isSubmitting">
      Cancel
    </button>
    <button mat-raised-button 
    style="background:#1E3A8A;color:#FFFFFF;"

            (click)="onSubmit()"
            [disabled]="editForm.invalid || isSubmitting">
      <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
      <span *ngIf="!isSubmitting">{{ getSubmitButtonText() }}</span>
      <span *ngIf="isSubmitting">Saving...</span>
    </button>
  </div>
</div>
